module.exports = __webpack_public_path__ + "img/MN.fb70ea2f.svg";